import React, { useState, useEffect, forwardRef } from 'react';
import Grid from '@material-ui/core/Grid'
import { lightTheme } from "../../SharedComponents/SharedComponentStyles";
import { ThemeProvider } from "@material-ui/core"
import Box from '@material-ui/core/Box';
import MaterialTable from "material-table";
import AddBox from '@material-ui/icons/AddBox';
import ArrowDownward from '@material-ui/icons/ArrowDownward';
import Check from '@material-ui/icons/Check';
import ChevronLeft from '@material-ui/icons/ChevronLeft';
import ChevronRight from '@material-ui/icons/ChevronRight';
import Clear from '@material-ui/icons/Clear';
import DeleteOutline from '@material-ui/icons/DeleteOutline';
import Edit from '@material-ui/icons/Edit';
import FilterList from '@material-ui/icons/FilterList';
import FirstPage from '@material-ui/icons/FirstPage';
import LastPage from '@material-ui/icons/LastPage';
import Remove from '@material-ui/icons/Remove';
import SaveAlt from '@material-ui/icons/SaveAlt';
import Search from '@material-ui/icons/Search';
import ViewColumn from '@material-ui/icons/ViewColumn';
import axios from 'axios';
import Alert from '@material-ui/lab/Alert';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';
import CircularProgress from '@material-ui/core/CircularProgress';
import { useSelector, useDispatch } from "react-redux";

let mrpload = 0;
let workertypeload = 0;
let usersload = 0;

const tableIcons = {
    Add: forwardRef((props, ref) => <AddBox {...props} ref={ref} />),
    Check: forwardRef((props, ref) => <Check {...props} ref={ref} />),
    Clear: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
    Delete: forwardRef((props, ref) => <DeleteOutline {...props} ref={ref} />),
    DetailPanel: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
    Edit: forwardRef((props, ref) => <Edit {...props} ref={ref} />),
    Export: forwardRef((props, ref) => <SaveAlt {...props} ref={ref} />),
    Filter: forwardRef((props, ref) => <FilterList {...props} ref={ref} />),
    FirstPage: forwardRef((props, ref) => <FirstPage {...props} ref={ref} />),
    LastPage: forwardRef((props, ref) => <LastPage {...props} ref={ref} />),
    NextPage: forwardRef((props, ref) => <ChevronRight {...props} ref={ref} />),
    PreviousPage: forwardRef((props, ref) => <ChevronLeft {...props} ref={ref} />),
    ResetSearch: forwardRef((props, ref) => <Clear {...props} ref={ref} />),
    Search: forwardRef((props, ref) => <Search {...props} ref={ref} />),
    SortArrow: forwardRef((props, ref) => <ArrowDownward {...props} ref={ref} />),
    ThirdStateCheck: forwardRef((props, ref) => <Remove {...props} ref={ref} />),
    ViewColumn: forwardRef((props, ref) => <ViewColumn {...props} ref={ref} />)
};

const api = axios.create({
    baseURL: '/EmployeeDetails'
})
const api_1 = axios.create({
    baseURL: 'MasterDetails'
})

function UserManagement(props) { 
    const [mrp, setmrp] = useState([]);
    const [workertype, setworkertype] = useState([]);
    const [data, setData] = useState([]); //table data
    //for error handling setwage
    const [iserror, setIserror] = useState(false);
    const [errorMessages, setErrorMessages] = useState([]);

    const [CreatedUserId, setCreatedUserId] = useState(props.loginuser.response.employeeId);

    const [wage, setwage] = useState([]); 

    //for alert msg
    const [open, setopen] = useState(false);
    const [openAlert, setopenAlert] = useState("");
    const [openClassName, setopenClassName] = useState("");
    const [openType, setopenType] = useState("");
    const [alertsuccess, setalertsuccess] = useState("Success");
    //const [alerterror, setalerterror] = useState("Alert");
    const [alertsuccessclass, setalertsuccessclass] = useState("bg-light-green clr-white");
    //const [alerterrorclass, setalerterrorclass] = useState("bg-red clr-white");

    //for progress
    const [openLoader, setopenLoader] = useState(false);

    const token = useSelector((state) => state.saveAzureTokenReducer.token);
    const userDetails = useSelector(
    (state) => state.storeUserDetailsReducer.userData);
    const bearerToken = useSelector(
    (state) => state.saveBearerTokenReducer.bearerToken);
    const uId = useSelector((state) => state.saveUIDReducer.uid);

    const handleErrorClose = (e) => {
        setIserror(false);
    }

    function showMsg(popen, popenAlert, popenClassName, popenType) {
        setopen(popen);
        setopenAlert(popenAlert);
        setopenClassName(popenClassName);
        setopenType(popenType);
    }

    function handleClose() {
        setopen(false);
    }

    function getMRP() {
        const headers = {
            Authorization: "Bearer " + bearerToken,
            UserEmail: userDetails.emailId,
            userId: uId,
            RoleName: userDetails.roleName,
            Gid: userDetails.gid,
            Roleid: userDetails.roleId,
            //AzureToken: token,
          };
        api_1.get('/getTblMstMrpcontroller/',{
            headers: headers
        })
            .then(res => {
                var obj = res.data.reduce(function (acc, cur, i) {
                    acc[cur.mrpcontrollerId] = cur.mrpcontroller;
                    return acc;
                }, {});
                setmrp(obj);
                isProcessing(1,1);
            })
            .catch(error => {
                console.log("Error in hitting api at page load.")
            })
    }

    function getUsers() {
        const headers = {
            Authorization: "Bearer " + bearerToken,
            UserEmail: userDetails.emailId,
            userId: uId,
            RoleName: userDetails.roleName,
            Gid: userDetails.gid,
            Roleid: userDetails.roleId,
            //AzureToken: token,
          };
        api.get("/getAllEmployee",{
            headers: headers
        })
            .then(res => {
                setData(res.data);
                isProcessing(3,1);
            })
            .catch(error => {
                console.log("Error")
            })
    }

    function getWorkerType() {
        const headers = {
            Authorization: "Bearer " + bearerToken,
            UserEmail: userDetails.emailId,
            userId: uId,
            RoleName: userDetails.roleName,
            Gid: userDetails.gid,
            Roleid: userDetails.roleId,
            //AzureToken: token,
          };
        api_1.get('/getWorkerType/',{
            headers: headers
        })
            .then(res => {
                var obj = res.data.reduce(function (acc, cur, i) {
                    acc[cur.roleId] = cur.name;
                    return acc;
                }, {});
                setworkertype(obj);
                isProcessing(2,1);
            })
            .catch(error => {
                console.log("Error in hitting api at page load.")
            })
    }

    var columns = [
        { title: "*Roll No", field: "rollNo" },
        { title: "*First Name", field: "firstName" },
        { title: "*Last Name", field: "lastName" },
        { title: "*GID", field: "gid" }, 
        { title: '*Employee Type', field: 'roleId', lookup: workertype },
        { title: "*Wage Group", field: "wageGroup", lookup: wage },
        { title: "*MRP Controller", field: "mrpcontrollerId", lookup: mrp },
        { title: "Extra 1", field: "extra1" },
        { title: "Extra 2", field: "extra2" },
        { title: "Extra 3", field: "extra3" },
        { title: 'Id', field: 'employeeId', type: 'numeric', hidden: true }
    ]

    function isProcessing(type, val) {
        let val1 = mrpload;
        let val2 = workertypeload;
        let val3 = usersload;

        if (type === 1) {
            mrpload = val;
            val1 = val;
        }
        if (type === 2) {
            workertypeload = val;
            val2 = val;
        }
        if (type === 3) {
            usersload=val;
            val3 = val;
        }

        if (val1 === 1 && val2 === 1 && val3 === 1) {
            setopenLoader(false);
        }
    }

    useEffect(() => {
        console.log(props);
        setopenLoader(true);
        getUsers();
        getMRP();
        getWorkerType();
        GetWages();
    }, [])

    const handleRowUpdate = (newData, oldData, resolve) => {
        const headers = {
            Authorization: "Bearer " + bearerToken,
            UserEmail: userDetails.emailId,
            userId: uId,
            RoleName: userDetails.roleName,
            Gid: userDetails.gid,
            Roleid: userDetails.roleId,
            //AzureToken: token,
          };
        let errorList = [];
        if (newData.gid === "" || newData.gid === undefined || newData.gid === null) {
            errorList.push("Please enter GID");
        } 
        else {
            if (newData.gid.length !== 8) {
                errorList.push("Please enter valid GID");
            }
            let row = data.filter(x => x.gid.toUpperCase() == newData.gid.toUpperCase());
            if (row.length > 0) {
                if (row[0].employeeId !== newData.employeeId) {
                    errorList.push("GID already exist");
                }
            }
        }
        if (newData.rollNo === "" || newData.rollNo === undefined || newData.rollNo === null) {
            errorList.push("Please enter roll number");
        }
        if (newData.firstName === "" || newData.firstName === undefined || newData.firstName === null) {
            errorList.push("Please enter first Name");
        }
        if (newData.lastName === "" || newData.lastName === undefined || newData.lastName === null) {
            errorList.push("Please enter last Name");
        }
        if (newData.roleId === "" || newData.roleId === undefined || newData.roleId === null) {
            errorList.push("Please enter employee type");
        }
        if (newData.wageGroup === "" || newData.wageGroup === undefined || newData.wageGroup === null) {
            errorList.push("Please enter wage group");
        }
        if (newData.mrpcontrollerId === "" || newData.mrpcontrollerId === undefined || newData.mrpcontrollerId === null) {
            errorList.push("Please enter MRP controller");
        }
        // if (newData.employeeId === "" || newData.employeeId === undefined || newData.employeeId === null) {
        //     errorList.push("Please enter Employee ID");
        // }

        if (errorList.length < 1) {
            let employeeDet = {
                employeeId: Number(newData.employeeId),
                rollNo: Number(newData.rollNo),
                firstName: newData.firstName,
                lastName: newData.lastName,
                gid: newData.gid,
                roleId: Number(newData.roleId),
                wageGroup: Number(newData.wageGroup),
                mrpcontrollerId: Number(newData.mrpcontrollerId),
                extra1: newData.extra1,
                extra2: newData.extra2,
                extra3: newData.extra3,
                UserTypeId: Number(newData.roleId),
                modifiedBy: CreatedUserId,
                emailId: newData.emailId,
            }
            api.put("/UpdateEmployee/", employeeDet,{
                headers: headers
            })
                .then(res => {
                    if (res.data.result !== 1) {
                        errorList.push("");
                        setErrorMessages(errorList);
                        setIserror(false);
                        resolve();
                    }
                    else {
                        showMsg(true, "Roll Number " + newData.rollNo + " updated successfully.", alertsuccessclass, alertsuccess);
                        const dataUpdate = [...data];
                        const index = oldData.tableData.id;
                        dataUpdate[index] = newData;
                        setData([...dataUpdate]);
                        resolve();
                        setIserror(false);
                        setErrorMessages([]);
                    }
                })
                .catch(error => {
                    setErrorMessages(["Due to server error, we are unable to update the employee. Please try again, later."]);
                    setIserror(true);
                    resolve();
                })

        } else {
            setErrorMessages(errorList);
            setIserror(true);
            resolve();
        }
    }

    const handleRowAdd = (newData, resolve) => {
        const headers = {
            Authorization: "Bearer " + bearerToken,
            UserEmail: userDetails.emailId,
            userId: uId,
            RoleName: userDetails.roleName,
            Gid: userDetails.gid,
            Roleid: userDetails.roleId,
            //AzureToken: token,
          };   
        let errorList = [];
        
        if (newData.gid === "" || newData.gid === undefined || newData.gid === null) {
            errorList.push("Please enter valid GID");
        }
        else {
            if (newData.gid.length !== 8) {
                errorList.push("Please enter valid GID");
            }
            let row = data.filter(x => x.gid.toUpperCase() == newData.gid.toUpperCase());
            if (row.length > 0) {
                errorList.push("GID already exist");
            }
        }
        if (newData.rollNo === "" || newData.rollNo === undefined || newData.rollNo === null) {
            errorList.push("Please enter roll number");
        }
        if (newData.firstName === "" || newData.firstName === undefined || newData.firstName === null) {
            errorList.push("Please enter first Name");
        }
        if (newData.lastName === "" || newData.lastName === undefined || newData.lastName === null) {
            errorList.push("Please enter last Name");
        }
        if (newData.roleId === "" || newData.roleId === undefined || newData.roleId === null) {
            errorList.push("Please enter employee type");
        }
        if (newData.wageGroup === "" || newData.wageGroup === undefined || newData.wageGroup === null) {
            errorList.push("Please enter wage group");
        }
        if (newData.mrpcontrollerId === "" || newData.mrpcontrollerId === undefined || newData.mrpcontrollerId === null) {
            errorList.push("Please enter MRP controller");
        }    

        if (errorList.length < 1) { 
            let employeeDet = {
                //employeeId: Number(newData.employeeId),
                rollNo: Number(newData.rollNo),
                firstName: newData.firstName,
                lastName: newData.lastName,
                gid: newData.gid,
                roleId: Number(newData.roleId),
                wageGroup: Number(newData.wageGroup),
                mrpcontrollerId: Number(newData.mrpcontrollerId),
                extra1: newData.extra1,
                extra2: newData.extra2,
                extra3: newData.extra3,
                UserTypeId: Number(newData.roleId),
                createdBy: CreatedUserId,
                emailId: newData.emailId                
            }
            api.post("/SaveEmployee/", employeeDet,{
                headers: headers
            })
                .then(res => {
                    let dataToAdd = [...data];
                    newData.employeeId=res.data.result;
                    console.log(newData);
                    dataToAdd.push(newData);
                    setData(dataToAdd);
                    showMsg(true, "Roll Number " + newData.rollNo + " saved successfully.", alertsuccessclass, alertsuccess);
                    errorList.push("");
                    setErrorMessages([]);
                    setIserror(false);
                    resolve();
                })
                .catch(error => {
                    setErrorMessages(["Due to server error, we are unable to add the employee. Please try again, later."]);
                    setIserror(true)
                    resolve()
                })
        } else {
            setErrorMessages(errorList)
            setIserror(true)
            resolve()
        }
    }

    const handleRowDelete = (oldData, resolve) => {
        const headers = {
            Authorization: "Bearer " + bearerToken,
            UserEmail: userDetails.emailId,
            userId: uId,
            RoleName: userDetails.roleName,
            Gid: userDetails.gid,
            Roleid: userDetails.roleId,
            //AzureToken: token,
          };
        api.delete("/DeleteEmployee/" + oldData.employeeId,{
            headers: headers
        })
            .then(res => {
                showMsg(true, "Roll Number " + oldData.rollNo + " deleted successfully.", alertsuccessclass, alertsuccess);
                const dataDelete = [...data];
                const index = oldData.tableData.id;
                dataDelete.splice(index, 1);
                setData([...dataDelete]);
                resolve()
            })
            .catch(error => {
                setErrorMessages(["Delete failed! Server error"])
                setIserror(true)
                resolve()
            })
    }

    //function GetWages() {
    //    api_1.get('/getTblMstWageGroup_Rpt/')
    //        .then(res => {
    //            setwage(res.data);
    //        })
    //        .catch(error => {
    //            console.log("Error in hitting api at page load. : WageGroup")
    //        })
    //}

    function GetWages() {
        const headers = {
            Authorization: "Bearer " + bearerToken,
            UserEmail: userDetails.emailId,
            userId: uId,
            RoleName: userDetails.roleName,
            Gid: userDetails.gid,
            Roleid: userDetails.roleId,
            //AzureToken: token,
          };
        api_1.get('/getTblMstWageGroup_Rpt/',{
            headers: headers
        })
            .then(res => {
                //console.log("inside api WageGroup");
                //console.log(res.data);
                var obj = res.data.reduce(function (acc, cur, i) {
                    acc[cur.wageGroupId] = cur.wageGroup;
                    return acc;
                }, {});
                //console.log(obj);
                setwage(obj);
            })
            .catch(error => {
                console.log("Error in hitting api at page load.")
            })
    }

    return (
        <ThemeProvider theme={lightTheme}>
            <div className="master-layout-data">
                <Box paddingTop={{ xs: '5rem', sm: '2rem' }} className="">
                    <h3 className="clr-dark-blue d-flex jc-center mt-2 mb-1">User Management</h3>
                </Box>
                <Grid container spacing={1} className="d-flex jc-center mb-2 bdr-radius">
                    <Grid item xs={12} sm={11} className="userManagement mt-1 mb-1">
                        <div>
                            {iserror &&
                                <Alert severity="error" onClose={handleErrorClose}>
                                    {errorMessages.map((msg, i) => {
                                        return <div key={i}>{msg}</div>
                                    })}
                                </Alert>
                            }
                        </div>
                        <MaterialTable
                            title="Employee Database"
                            columns={columns}
                            data={data}
                            icons={tableIcons}
                            editable={{
                                onRowUpdate: (newData, oldData) =>
                                    new Promise((resolve,reject) => {
                                        handleRowUpdate(newData, oldData,resolve,reject);
                                    }),
                                onRowAdd: (newData) =>
                                    new Promise((resolve) => {
                                        handleRowAdd(newData, resolve)
                                    }),
                                onRowDelete: (oldData) =>
                                    new Promise((resolve) => {
                                        handleRowDelete(oldData, resolve)
                                    }),
                            }}
                            options={{
                                pageSizeOptions: [30, 40, 50],    // rows selection options
                                pageSize: 30,
                                maxBodyHeight: 600,
                                addRowPosition:'first',
                            }}
                        />
                    </Grid>
                </Grid>
                <Dialog
                    open={open}
                    onClose={handleClose}
                    aria-labelledby="draggable-dialog-title"
                    id="templateUploadSuccess">
                    <DialogTitle className={openClassName} style={{ cursor: 'move' }} id="draggable-dialog-title">
                        {openType}
                    </DialogTitle>
                    <DialogContent>
                        <DialogContentText className="clr-black">
                            {openAlert}
                        </DialogContentText>
                    </DialogContent>
                    <DialogActions>
                        <Button variant="contained" autoFocus onClick={handleClose} className="ns-btn-secondary-light">
                            <span className="f-16 fw-bold">OK</span>
                        </Button>
                    </DialogActions>
                </Dialog>
                <Dialog
                    open={openLoader}
                    //onClose={handleClose}
                    aria-labelledby="draggable-dialog-title"
                    id="templateUploadSuccess"
                    PaperProps={{
                        style: {
                            backgroundColor: "transparent",
                            boxShadow: "none",
                            borderColor: "transparent"
                        },
                    }}
                >
                    <DialogContent>
                        <CircularProgress />
                    </DialogContent>
                </Dialog>
            </div>
        </ThemeProvider>
    );
}

export default UserManagement;